import React from 'react';
import { NotificationService } from 'ui-components/services/notification-service';
import { LocalStorageService } from '../../services/local-storage-service';
import * as AnnouncementsApi from './announcements.api';

// Only use this export for testing.
export class AnnouncementManagerClass {
  constructor({ notificationService, localStorageService, announcementsApi, delayTime }) {
    const fourHours = 1000 * 60 * 60 * 4;
    this.notificationService = notificationService;
    this.localStorageService = localStorageService;
    this.announcementsApi = announcementsApi;
    this.delayTime = delayTime || fourHours;

    this.announcements = {};
    this.delayedAnnouncementTimeouts = {};

    this.removeNotification = this.removeNotification.bind(this);
    this.dismissAnnouncement = this.dismissAnnouncement.bind(this);
    this.getDelayedAnnouncement = this.getDelayedAnnouncement.bind(this);
    this.showAnnouncement = this.showAnnouncement.bind(this);
    this.delayAnnouncement = this.delayAnnouncement.bind(this);
    this.getDelayedAnnouncementName = this.getDelayedAnnouncementName.bind(this);
  }

  getDelayedAnnouncementName(announcementId) {
    return `announcement-delay-${announcementId}`;
  }

  removeNotification(announcementId) {
    const notificationId = this.announcements[announcementId];

    if (notificationId) {
      this.notificationService.removeNotification(notificationId);
    }
  }

  dismissAnnouncement(announcementId) {
    if (!announcementId) {
      return;
    }

    this.removeNotification(announcementId);
    this.announcements[announcementId] = '';
    this.announcementsApi.dismissAnnouncement(announcementId);
  }

  delayAnnouncement(announcement) {
    const announcementDelay = {
      announcement,
      showAt: Date.now() + this.delayTime,
    };

    const { announcementId } = announcement;

    this.localStorageService.setItem(this.getDelayedAnnouncementName(announcementId), announcementDelay);
    this.delayedAnnouncementTimeouts[announcementId] = setTimeout(() => this.showAnnouncement(announcement), this.delayTime);
    this.removeNotification(announcementId);
  }

  getDelayedAnnouncement(announcementId) {
    return this.localStorageService.getItem(this.getDelayedAnnouncementName(announcementId));
  }

  showAnnouncement(announcement) {
    if (!announcement) {
      return;
    }

    const { announcementId } = announcement;
    const delayedAnnouncement = this.getDelayedAnnouncement(announcementId);
    const isAnnouncementDelayed = delayedAnnouncement && delayedAnnouncement.showAt > Date.now();

    if (isAnnouncementDelayed) {
      const timeRemaining = delayedAnnouncement.showAt - Date.now();
      this.delayedAnnouncementTimeouts[announcementId] =
        this.delayedAnnouncementTimeouts[announcementId] || setTimeout(() => this.showAnnouncement(announcement), timeRemaining);
      return;
    }

    const content = (
      // oxlint-disable-next-line react/no-danger
      <div dangerouslySetInnerHTML={{ __html: announcement.content }} />
    );
    const notificationId = this.notificationService.showNotification({
      content,
      title: announcement.title,
      dontHide: true,
      buttons: [
        {
          text: 'Dismiss',
          callback: () => this.dismissAnnouncement(announcementId),
        },
        {
          text: 'Show Me Later',
          callback: () => this.delayAnnouncement(announcement),
        },
      ],
    });

    delete this.delayedAnnouncementTimeouts[announcementId];

    this.announcements[announcementId] = notificationId;
  }
}

export const AnnouncementManager = new AnnouncementManagerClass({
  notificationService: NotificationService,
  localStorageService: LocalStorageService,
  announcementsApi: AnnouncementsApi,
});
